import { render, staticRenderFns } from "./HmRedpackageGuiderAlias.vue?vue&type=template&id=2dfa486d&scoped=true&"
import script from "./HmRedpackageGuiderAlias.vue?vue&type=script&lang=js&"
export * from "./HmRedpackageGuiderAlias.vue?vue&type=script&lang=js&"
import style0 from "./HmRedpackageGuiderAlias.vue?vue&type=style&index=0&id=2dfa486d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa486d",
  null
  
)

component.options.__file = "HmRedpackageGuiderAlias.vue"
export default component.exports